type UnleashOrganization = {
  readonly id: string
  readonly slug: string | null
  readonly name: string
}

export type UnleashUser = {
  readonly id: string
  readonly organizationMemberships?: readonly {
    readonly organization: UnleashOrganization
  }[]
}

/**
 * Takes the user's membership, not the Clerk active organization, which a
 * session can lack. Targeting rules: docs/admin/feature-flag-targeting.md.
 */
export function buildUnleashContext(user: UnleashUser): Record<string, string> {
  const organization = user.organizationMemberships?.[0]?.organization

  const context: Record<string, string> = { userId: user.id }
  if (organization?.id) context.organizationId = organization.id
  if (organization?.slug) context.organizationSlug = organization.slug
  if (organization?.name) context.organizationName = organization.name
  return context
}
